"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chunks = void 0;
if (!Array.prototype.firstOrUndefined) {
    Array.prototype.firstOrUndefined = function () {
        return this.length > 0 ? this[0] : undefined;
    };
}
if (!Array.prototype.undefinedIfEmpty) {
    Array.prototype.undefinedIfEmpty = function () {
        return this.length > 0 ? this : undefined;
    };
}
if (!Array.prototype.filterTruthy) {
    Array.prototype.filterTruthy = function () {
        return this.filter((item) => item);
    };
}
function* chunks(arr, n) {
    for (let i = 0; i < arr.length; i += n) {
        yield arr.slice(i, i + n);
    }
}
exports.chunks = chunks;
//# sourceMappingURL=arrays.js.map